import { DataTable } from '../DataTable/DataTable'
import { buildInventorySystemProfilesTableColumns } from './helpers/buildInventorySystemProfilesTableColumns'
import type { InventorySystemProfilesTableProps } from './InventorySystemProfilesTable.types'

export function InventorySystemProfilesTable({
  profiles,
  tenantGroups,
  onRowClick,
}: InventorySystemProfilesTableProps) {
  return (
    <DataTable
      columns={buildInventorySystemProfilesTableColumns(tenantGroups)}
      data={profiles}
      rowKey={(p) => p.id}
      emptyMessage="No inventory system profiles found."
      onRowClick={onRowClick}
    />
  )
}
